export const NETWORKS_NAMES = {
  BTC: 'Bitcoin',
  ETH: 'ERC20',
  TRX: 'TRC20',
  BSC: 'BEP20',
  BNB: 'BEP20',
  XRP: 'Ripple',
  MATIC: 'Polygon',
  SOL: 'Solana'
};

export const NETWORKS_DETAILED_NAMES = {
  matic: 'Polygon'
};
